// extracted by mini-css-extract-plugin
export default {"rating":"ME-z","numberOfStars":"NE-z","count":"OE-z","barGraphSpacing":"PE-z","barGraph":"QE-z"};